import { useMutation, useQuery } from '@tanstack/react-query';
import {
  createSuitabilityTest,
  getQuestionnaireContent,
  previewSuitability,
} from './suitability-api';
import {
  clientSuitabilityTests,
  suitabilityPreview,
  suitabilityQuestionnaire,
} from '../constants/urls';
import type { CreateSuitabilityTestRequest } from './interfaces';

/** Contenido/textos del cuestionario vigente (cacheado toda la sesión). */
export const useQuestionnaireContent = (language: string) =>
  useQuery({
    queryKey: [suitabilityQuestionnaire, language],
    queryFn: () => getQuestionnaireContent(language),
    staleTime: Infinity,
  });

/** Calculates the result without persisting (call when reaching the summary). */
export const usePreviewSuitability = () =>
  useMutation({
    mutationKey: [suitabilityPreview],
    mutationFn: (variables: {
      answers: Record<string, unknown>;
      questionnaireVersion: string;
    }) => previewSuitability(variables.answers, variables.questionnaireVersion),
  });

/** Persiste el test del cliente con el PDF ya revisado (en el body JSON, base64). */
export const useCreateSuitabilityTest = (clientId: string) =>
  useMutation({
    mutationKey: [clientSuitabilityTests, clientId],
    mutationFn: (request: CreateSuitabilityTestRequest) =>
      createSuitabilityTest(clientId, request),
  });
